<script>
    /* Док macOS: иконка под курсором вырастает, соседние — слабее.
       Масштаб растёт от нижней кромки (transform-origin в стилях), поэтому
       иконки «выпрыгивают» вверх, как на настоящем ноутбуке.
       Подпись рисуется НЕ внутри иконки, а отдельным элементом дока — иначе она
       росла бы вместе с ней и уезжала вверх. */
    import PadIcon from './padicon.svelte';

    export let apps = [];
    export let active = 'mainmenu';
    export let onOpen = () => {};
    export let onClose = () => {};

    let dockEl;
    let hover = -1;
    let tip = null;

    /* ⚠️ Масштабы считаем В РЕАКТИВНОМ выражении, где hover назван явно.
       Если спрятать его внутрь функции (style="scale({scaleFor(i)})"), Svelte
       не увидит зависимость и не перерисует атрибут — иконки не вырастут. */
    const step = (d) => d === 0 ? 1.5 : d === 1 ? 1.26 : d === 2 ? 1.1 : 1;

    $: scales = apps.map ((a, i) => hover < 0 ? 1 : step (Math.abs (i - hover)));
    $: closeScale = hover < 0 ? 1 : step (Math.abs (apps.length + 1 - hover));

    // центр иконки меряем до увеличения — по горизонтали он не двигается
    const onEnter = (event, i, name) => {
        hover = i;
        try {
            const r = event.currentTarget.getBoundingClientRect ();
            const d = dockEl.getBoundingClientRect ();
            tip = { x: r.left - d.left + r.width / 2, text: name };
        } catch (e) {
            tip = null;
        }
    }

    const onLeave = () => { hover = -1; tip = null; }
</script>

<div class="macdock" bind:this={dockEl} on:mouseleave={onLeave}>
    {#each apps as app, i}
        <div class="macdock__item {app.tone || 'grey'}"
             class:is-open={active === app.id}
             data-app={app.id}
             style="transform: scale({scales[i] || 1})"
             on:mouseenter={(e) => onEnter (e, i, app.name)}
             on:keypress={() => {}}
             on:click={() => onOpen (app)}>
            <PadIcon name={app.icon} size="2.9vh"/>
        </div>
    {/each}

    <div class="macdock__sep"></div>

    <div class="macdock__item grey"
         style="transform: scale({closeScale})"
         on:mouseenter={(e) => onEnter (e, apps.length + 1, 'Закрыть ноутбук')}
         on:keypress={() => {}}
         on:click={onClose}>
        <PadIcon name="power" size="2.9vh"/>
    </div>

    {#if tip}
        <div class="macdock__tip" style="left: {tip.x}px">{tip.text}</div>
    {/if}
</div>
